import Vue from "vue";

import ErrorHandler from "@/helpers/handlers/error";
import { i18n } from "@/main";

export function getTwoFactorErrorCode(error) {
  return error && error.response && error.response.data
    ? error.response.data.error_code
    : null;
}

export function displayTwoFactorError(error) {
  const errorCode = getTwoFactorErrorCode(error);
  const translationKey = `message.twoFactor.errors.${errorCode}`;

  if (!errorCode || !i18n.te(translationKey)) {
    ErrorHandler.displayError(error);
    return;
  }

  Vue.notify({
    group: "default",
    type: "error",
    text: i18n.t(translationKey)
  });
}
